import { useEffect, useState } from "react";
import SideNavBar from "../components/SideNavBar";
import {
  getErrorMessage,
  getSaleDetail,
  getSales,
  getTypes,
} from "../services/authApi";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

function SalesPage({ user, onLogout }) {
  const [sales, setSales] = useState([]);
  const [paymentTypes, setPaymentTypes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [pageError, setPageError] = useState("");
  const [filters, setFilters] = useState({
    search: "",
    paymentTypeId: "",
    dateFrom: "",
    dateTo: "",
  });

  const [currentPage, setCurrentPage] = useState(1);
  const [lastPage, setLastPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [total, setTotal] = useState(0);
  const [detailLoading, setDetailLoading] = useState(false);
  const [detailError, setDetailError] = useState("");

  const formatMoney = (value) => Number(value || 0).toLocaleString("en-US");

  const formatDate = (dateStr) => {
  if (!dateStr) return "-";

  const d = new Date(dateStr);

  const day = String(d.getDate()).padStart(2, "0");

  const months = [
    "Jan","Feb","Mar","Apr","May","Jun",
    "Jul","Aug","Sep","Oct","Nov","Dec"
  ];

  const month = months[d.getMonth()];
  const year = d.getFullYear();

  return `${day}-${month}-${year}`;
};

 const generatePDF = (sale) => {
  const doc = new jsPDF("p", "mm", "a4");
  const pageWidth = doc.internal.pageSize.getWidth();

  doc.setFont("helvetica", "bold");
  doc.setFontSize(14);
  doc.text("MYANMAR DUTY FREE", pageWidth / 2, 15, { align: "center" });

  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);

  doc.text("Yangon Duty Free", 20, 25);
  doc.text("Ph : 09-448011645", 20, 35);

  doc.text("Mandalay Duty Free", pageWidth - 20, 25, { align: "right" });
  doc.text("Ph : 09-973071555", pageWidth - 20, 35, { align: "right" });

  doc.setFontSize(11);

  // LEFT FIELDS
  doc.text("Customer", 15, 50);
  doc.text(":", 45, 50);
  doc.text(sale.customer || "-", 55, 50);
  doc.line(55, 52, 115, 52);

  doc.text("Address", 15, 62);
  doc.text(":", 45, 62);
  doc.text(sale.address || "", 55, 62);
  doc.line(55, 64, 115, 64);

  // RIGHT FIELDS
  doc.text("Invoice No.", 125, 50);
  doc.text(":", 160, 50);
  doc.text(sale.invoice_number || "-", 168, 50);
  doc.line(168, 52, 198, 52);

 doc.text("Date", 125, 62);
doc.text(":", 160, 62);
doc.text(formatDate(sale.created_at), 168, 62);
  doc.line(168, 64, 198, 64);

  const items = sale.sale_items || [];

  const body = items.map((line, index) => {
    const price = Number(line.item?.price || line.price || 0);
    const qty = Number(line.quantity || 0);
    const amount = Number(line.total_amount || price * qty);

    return [
      index + 1,
      line.item?.barcode || line.item_code || line.item?.id || "-",
      line.item?.name || "-",
      qty,
      formatMoney(price),
      `${Number(line.discount_percent || 0)}%`,
      formatMoney(amount),
    ];
  });

  autoTable(doc, {
    startY: 76,
    margin: { left: 10, right: 10 },
    tableWidth: 190,
    head: [["Line", "Code", "Description", "Qty", "Price", "Dis%", "Amount"]],
    body,
    theme: "grid",
    styles: {
      fontSize: 10,
      cellPadding: 2,
      lineColor: [0, 0, 0],
      lineWidth: 0.2,
      textColor: [0, 0, 0],
      overflow: "linebreak",
    },
    headStyles: {
      fillColor: [220, 220, 220],
      textColor: [0, 0, 0],
      fontStyle: "bold",
      halign: "center",
    },
    columnStyles: {
      0: { halign: "center", cellWidth: 12 },
      1: { cellWidth: 24 },
      2: { cellWidth: 65 },
      3: { halign: "center", cellWidth: 16 },
      4: { halign: "right", cellWidth: 25 },
      5: { halign: "center", cellWidth: 18 },
      6: { halign: "right", cellWidth: 30 },
    },
  });

  const totalAmount = Number(sale.total_amount || 0);
  const discountAmount =
    Number(sale.discount_amount || 0) ||
    (totalAmount * Number(sale.discount_percentage || 0)) / 100;
  const netAmount = totalAmount - discountAmount;

  const summaryY = doc.lastAutoTable.finalY + 8;

  autoTable(doc, {
    startY: summaryY,
    margin: { left: 125, right: 10 },
    tableWidth: 75,
    body: [
      ["Total", formatMoney(totalAmount)],
      ["Discount", formatMoney(discountAmount)],
      ["Net Amount", formatMoney(netAmount)],
    ],
    theme: "grid",
    styles: {
      fontSize: 12,
      cellPadding: 3,
      lineColor: [0, 0, 0],
      lineWidth: 0.2,
      textColor: [0, 0, 0],
    },
    columnStyles: {
      0: { fontStyle: "bold", halign: "right", cellWidth: 35 },
      1: { fontStyle: "bold", halign: "right", cellWidth: 40 },
    },
  });

  const signY = 260;

  doc.line(15, signY, 60, signY);
  doc.text("Customer Signature", 17, signY + 6);

  doc.line(80, signY, 125, signY);
  doc.text("Sale Signature", 85, signY + 6);

  doc.line(145, signY, 190, signY);
  doc.text("Cashier Signature", 150, signY + 6);

  const pdfBlob = doc.output("blob");
  const pdfUrl = URL.createObjectURL(pdfBlob);

  window.open(pdfUrl, "_blank");

  setTimeout(() => URL.revokeObjectURL(pdfUrl), 10000);
};

  const loadSales = async (
    page = 1,
    nextPerPage = perPage,
    nextFilters = filters
  ) => {
    try {
      setLoading(true);

      const [salesData, typesData] = await Promise.all([
        getSales({
          page,
          per_page: nextPerPage,
          search: nextFilters.search || undefined,
          payment_type_id: nextFilters.paymentTypeId || undefined,
          date_from: nextFilters.dateFrom || undefined,
          date_to: nextFilters.dateTo || undefined,
        }),
        getTypes(),
      ]);

      const salesList = Array.isArray(salesData)
        ? salesData
        : salesData?.data || [];

      setSales(salesList);
      setPaymentTypes(Array.isArray(typesData) ? typesData : typesData?.data || []);

      if (!Array.isArray(salesData)) {
        setCurrentPage(salesData.current_page || 1);
        setLastPage(salesData.last_page || 1);
        setPerPage(salesData.per_page || nextPerPage);
        setTotal(salesData.total || salesList.length);
      } else {
        setCurrentPage(1);
        setLastPage(1);
        setTotal(salesList.length);
      }

      setPageError("");
    } catch (requestError) {
      setPageError(getErrorMessage(requestError, "Failed to load sales records."));
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadSales();
  }, []);

  const handleFilterChange = (field, value) => {
    setFilters((prev) => ({ ...prev, [field]: value }));
  };

  const applyFilters = () => {
    loadSales(1, perPage, filters);
  };

  const resetFilters = () => {
    const cleared = {
      search: "",
      paymentTypeId: "",
      dateFrom: "",
      dateTo: "",
    };

    setFilters(cleared);
    loadSales(1, perPage, cleared);
  };

  const goToPage = (page) => {
    if (page < 1 || page > lastPage || page === currentPage) return;
    loadSales(page, perPage, filters);
  };

  const handlePerPageChange = (value) => {
    const nextPerPage = Number(value);
    setPerPage(nextPerPage);
    loadSales(1, nextPerPage, filters);
  };

  const openDetail = async (saleId) => {
    setDetailLoading(true);
    setDetailError("");

    try {
      const sale = await getSaleDetail(saleId);
      console.log("Sale detail:", sale);
      generatePDF(sale);
    } catch (requestError) {
      console.log("Error fetching sale detail:", requestError);
      setDetailError(getErrorMessage(requestError, "Failed to load sale detail."));
    } finally {
      setDetailLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen flex-col bg-gradient-to-br from-maroon-50 to-maroon-100 md:flex-row">
      <SideNavBar user={user} onLogout={onLogout} />

      <div className="flex flex-1 p-4 md:p-6">
        <div className="w-full rounded-2xl bg-white p-4 shadow-xl shadow-maroon-900/10 md:p-6">
          <h1 className="mb-5 text-3xl font-bold text-maroon-900">
            Sales Records
          </h1>

          <div className="mb-5 grid gap-3 rounded-lg border border-maroon-100 bg-maroon-50 p-4 sm:grid-cols-2 md:grid-cols-5">
            <input
              type="text"
              value={filters.search}
              onChange={(event) =>
                handleFilterChange("search", event.target.value)
              }
              placeholder="Search sale id / user"
              className="rounded-lg border border-maroon-200 px-3 py-2 text-sm outline-none ring-maroon-300 focus:ring-2"
            />

            <select
              value={filters.paymentTypeId}
              onChange={(event) =>
                handleFilterChange("paymentTypeId", event.target.value)
              }
              className="rounded-lg border border-maroon-200 px-3 py-2 text-sm outline-none ring-maroon-300 focus:ring-2"
            >
              <option value="">All payments</option>
              {paymentTypes.map((type) => (
                <option key={type.id} value={type.id}>
                  {type.name}
                </option>
              ))}
            </select>

            <input
              type="date"
              value={filters.dateFrom}
              onChange={(event) =>
                handleFilterChange("dateFrom", event.target.value)
              }
              className="rounded-lg border border-maroon-200 px-3 py-2 text-sm outline-none ring-maroon-300 focus:ring-2"
            />

            <input
              type="date"
              value={filters.dateTo}
              onChange={(event) =>
                handleFilterChange("dateTo", event.target.value)
              }
              className="rounded-lg border border-maroon-200 px-3 py-2 text-sm outline-none ring-maroon-300 focus:ring-2"
            />

            <div className="flex gap-2">
              <button
                type="button"
                onClick={applyFilters}
                className="rounded-lg bg-maroon-700 px-3 py-2 text-xs font-semibold text-white hover:bg-maroon-800"
              >
                Apply
              </button>

              <button
                type="button"
                onClick={resetFilters}
                className="rounded-lg border border-maroon-300 px-3 py-2 text-xs font-semibold text-maroon-800 hover:bg-maroon-100"
              >
                Reset
              </button>
            </div>
          </div>

          {loading && <p className="text-maroon-700">Loading sales...</p>}
          {pageError && <p className="font-medium text-red-600">{pageError}</p>}
          {detailError && <p className="font-medium text-red-600">{detailError}</p>}

          {!loading && !pageError && (
            <div className="overflow-x-auto rounded-lg border border-maroon-100">
              <table className="min-w-full text-left text-sm">
                <thead className="bg-maroon-50 text-maroon-900">
                  <tr>
                    <th className="px-4 py-3 font-semibold">Invoice</th>
                    <th className="px-4 py-3 font-semibold">Date</th>
                    <th className="px-4 py-3 font-semibold">Customer</th>
                    <th className="px-4 py-3 font-semibold">Qty</th>
                    <th className="px-4 py-3 font-semibold">Total</th>
                    <th className="px-4 py-3 font-semibold">Received</th>
                    <th className="px-4 py-3 font-semibold">Receivable</th>
                    <th className="px-4 py-3 font-semibold">Payment</th>
                    <th className="px-4 py-3 font-semibold">Action</th>
                  </tr>
                </thead>

                <tbody>
                  {sales.length === 0 ? (
                    <tr>
                      <td className="px-4 py-3 text-maroon-700" colSpan={9}>
                        No sales found.
                      </td>
                    </tr>
                  ) : (
                    sales.map((sale, index) => (
                      <tr
                        key={sale.id || index}
                        className="border-t border-maroon-100"
                      >
                        <td className="px-4 py-3 font-semibold text-maroon-800">
                          {sale.invoice_number || "-"}
                        </td>

                        <td className="px-4 py-3 text-maroon-800">
                          {sale.created_at
                            ? new Date(sale.created_at).toLocaleString()
                            : "-"}
                        </td>

                        <td className="px-4 py-3 text-maroon-800">
                          {sale.customer || "-"}
                        </td>

                        <td className="px-4 py-3 text-maroon-800">
                          {sale.quantity}
                        </td>

                        <td className="px-4 py-3 text-maroon-800">
                          {sale.total_amount}
                        </td>

                        <td className="px-4 py-3 text-maroon-800">
                          {sale.actual_received || 0}
                        </td>

                        <td className="px-4 py-3 font-semibold text-red-600">
                          {sale.receivable_amount || 0}
                        </td>

                        <td className="px-4 py-3 text-maroon-800">
                          {sale.payment_type?.name ||
                            sale.paymentType?.name ||
                            "-"}
                        </td>

                        <td className="px-4 py-3">
                          <button
                            type="button"
                            onClick={() => openDetail(sale.id)}
                            disabled={detailLoading}
                            className="rounded-md bg-maroon-700 px-3 py-1 text-xs font-semibold text-white hover:bg-maroon-800 disabled:opacity-50"
                          >
                            {detailLoading ? "Generating..." : "View PDF"}
                          </button>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          )}

          {!loading && !pageError && (
            <div className="mt-4 flex flex-wrap items-center justify-between gap-3">
              <p className="text-sm text-maroon-700">
                Showing page {currentPage} of {lastPage} ({total} records)
              </p>

              <div className="flex items-center gap-2">
                <label className="text-sm text-maroon-800" htmlFor="per_page">
                  Per page
                </label>

                <select
                  id="per_page"
                  value={perPage}
                  onChange={(event) => handlePerPageChange(event.target.value)}
                  className="rounded-lg border border-maroon-200 px-2 py-1 text-sm outline-none ring-maroon-300 focus:ring-2"
                >
                  <option value={5}>5</option>
                  <option value={10}>10</option>
                  <option value={20}>20</option>
                  <option value={50}>50</option>
                </select>

                <button
                  type="button"
                  disabled={currentPage <= 1}
                  onClick={() => goToPage(currentPage - 1)}
                  className="rounded-lg border border-maroon-300 px-3 py-1 text-sm font-semibold text-maroon-800 disabled:opacity-50"
                >
                  Prev
                </button>

                <button
                  type="button"
                  disabled={currentPage >= lastPage}
                  onClick={() => goToPage(currentPage + 1)}
                  className="rounded-lg border border-maroon-300 px-3 py-1 text-sm font-semibold text-maroon-800 disabled:opacity-50"
                >
                  Next
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default SalesPage;